<template>
  <!--合同显示-->
  <div class="contract-view" ref="bigBox">
    <p class="text-center page-shwo">{{page}}/{{items}}</p>

    <!--放大镜大图容器-->
    <div class="big-box" v-if="url">
      <!--合同容器-->
      <div class="cont-box" ref="contBox">
        <img
          @load="handleImgLoad"
          v-if="url"
          :src="url"
          :key="page"
          alt="合同信息"
          style="width: 100%;height: 100%"
        />
        <!--章显示-->
        <div class="chapter-list">
          <template v-for="(item) in chapterList" v-if="item.page === (page -1)">
            <div
              :ref="'sign'+item.cindex"
              :key="item.cindex"
              class="cachet-box"
              style="display:none"
              :style="handleSetChapte(item)"
              :data-cindex="item.cindex"
            >
              <!-- 之前版本使用图片 -->
              <!--             <p @click="delChapter(item.cindex)">
                                <a v-if="isCreate" href="javascript:void (0)" class="el-icon-error color-danger del-chapter del-chapter__create"></a>
                                <a v-else href="javascript:void (0)" class="el-icon-circle-close color-danger del-chapter del-chapter__sign"></a>
                              </p>
              <img @mousedown="handleCacheMousedown"  :src="item.url" :data-cindex="item.cindex" class="chapte-img"/>-->

              <!-- 现在版自定义样式 -->
              <div :class="{'qz-new':true,'draging':cachetMove && currentIndex===item.cindex}">
                <a
                  @click="delChapter(item.cindex)"
                  href="javascript:void (0)"
                  class="el-icon-error color-danger del-chapter del-chapter__sign"
                ></a>
                <div @mousedown.capture="handleCacheMousedown($event,item.cindex)">
                  <h1>{{item.signOwner || '签署方'+item.cindex}}</h1>
                  <div class="con">{{item.qsInfo | eclipse}}</div>
                  <img src="../../static/img/move-icon.png" />
                  <span class="time">日期：XXXX</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!--切换按钮-->
        <div @click="handlePrePage" v-if="page > 1" ref="pre" class="pre">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div @click="handleNextPage" v-if="page < items" ref="next" class="next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      elBox: { width: 0, height: 0 },
      imgBox: { width: 0, height: 0 },
      // 当前用户选中拖拽的章的dom对象
      objCurrentCachet: null,
      cachetMove: false,
      currentIndex: null // 当前拖动的item
      // 切换按钮位置
      // preLeft: null,
      // nextLeft: null
    }
  },
  props: {
    // 合同图片
    url: { type: String, default: '' },
    // 签章列表
    chapterList: { type: Array },
    // 总页数
    items: { type: Number, default: 0 },
    // 当前页
    page: { type: Number, default: 1 }
  },
  watch: {
    chapterList: {
      handler (val) {
        this.$emit('update:chapterList', val)
      },
      deep: true
    },
    contractInfo: {
      handler (val) {
        this.$emit('update:contractInfo', val)
      },
      deep: true
    }
  },
  filters: {
    eclipse (value) {
      if (!value) return ''
      let maxNum = 23
      value = value + ''
      return value.length > maxNum ? value.substr(0, maxNum) + '...' : value
    }
  },
  methods: {
    /**
     * js根据节点名称，查找某节点的特定父节点
     * @className 父节点中含有当前class的节点
     * */
    getParentNode (node, className) {
      if (!node) return ''
      if (node.nodeName == 'BODY') return node
      let tnode = node.parentNode
      let cName = tnode.getAttribute('class')
      if (cName === className) return tnode
      return this.getParentNode(tnode, className)
    },
    // 计算签章初始化位置
    handleSetChapte (chapte) {
      let contBoxDomList = null
      let dom
      let timer = setTimeout(() => {
        contBoxDomList = document.querySelectorAll('.cont-box img')
        for (let i = 0; i < contBoxDomList.length; i++) {
          if (contBoxDomList[i].src === this.url) {
            dom = contBoxDomList[i]
            break
          }
        }
        console.log('url', this.url)
        console.log('dom1', dom, contBoxDomList)
        if (!dom) {
          dom = contBoxDomList[0]
        }
        if (dom) {
          clearTimeout(timer)
          let { offsetX, offsetY, imageHeight, cindex } = chapte
          console.log('offsetX', offsetX, offsetY)
          let imgW = dom.width || dom.clientWidth || dom.naturalWidth
          let imgH = dom.height || dom.clientHeight || dom.naturalHeight
          console.log(imgH * offsetY, offsetY, imgH, '???>>>chushi')
          console.log(this.$refs['sign' + cindex])
          this.$refs['sign' + cindex][0].style.top = imgH * offsetY + 'px'
          this.$refs['sign' + cindex][0].style.left = imgW * offsetX + 'px'
          this.$refs['sign' + cindex][0].style.display = 'inline-block'
          // console.log('return', {top: imgH * offsetY + 'px', left: imgW * offsetX + 'px'})
          // return { top: imgH * offsetY + 'px', left: imgW * offsetX + 'px' }
        }
      }, 100)

      // for (let i = 0; i < contBoxDomList.length; i++) {
      //   if (contBoxDomList[i].src === this.url) {
      //     dom = contBoxDomList[i]
      //     break
      //   }
      // }
      // console.log('dom1', dom, contBoxDomList)
      // if (!dom) {
      //   dom = contBoxDomList[0]
      // }
    },
    // 上一页 点击方法
    handlePrePage () {
      if (this.page > 1) {
        this.$emit('pre-page', this.page - 1)
      }
    },
    // 下一页合同 点击方法
    handleNextPage () {
      if (this.page < this.items) {
        this.$emit('next-page', this.page + 1)
      }
    },
    // 合同加载完成，初始化界面
    handleImgLoad: function (el) {
      el = el.target
      let imgEl = el
      this.imgBox = {
        width: imgEl.width || imgEl.naturalWidth,
        height: imgEl.height || imgEl.naturalHeight
      }
    },
    /** ******* 签章拖拽效果 start ************/
    // 签章停止事件
    handleCacheStop: function (el) {
      el.preventDefault()
      this.doCachetStop()
    },
    // 签章鼠标按下事件
    handleCacheMousedown: function (el, currentIndex) {
      el.preventDefault()
      this.doCachetStart()
      this.currentIndex = currentIndex // 记录当前拖动的第几项
      this.objCurrentCachet = this.getParentNode(el.target, 'cachet-box') // 获取move dom
      if (!this.objCurrentCachet) return

      document.addEventListener('mousemove', this.handleCacheMousemove, false)
      document.addEventListener('mouseup', this.handleCacheStop, false)
    },
    // 签章随着鼠标移动事件
    handleCacheMousemove: function (el) {
      el.preventDefault()
      if (!this.cachetMove && !this.objCurrentCachet) return
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector('.cont-box').getBoundingClientRect()
      let { clientX: mouseX, clientY: mouseY } = el
      let {
        width: caechetW,
        height: caechetH
      } = this.objCurrentCachet.getBoundingClientRect()

      let top = mouseY - contBoxTop - caechetH / 2
      let left = mouseX - contBoxLeft - caechetW / 2

      if (top < 35) {
        top = 35
      } else if (top > contBoxH - caechetH - 35) {
        top = contBoxH - caechetH - 35
      }

      if (left < 35) {
        left = 35
      } else if (left > contBoxW - caechetW - 35) {
        left = contBoxW - caechetW - 35
      }

      this.objCurrentCachet.style.top = `${top}px`
      this.objCurrentCachet.style.left = `${left}px`
    },

    // 签章停止移动
    doCachetStop: function () {
      this.cachetMove = false
      this.currentIndex = null

      document.removeEventListener(
        'mousemove',
        this.handleCacheMousemove,
        false
      )
      document.removeEventListener('mouseup', this.handleCacheStop, false)

      if (this.objCurrentCachet) {
        // this.objCurrentCachet['style'].opacity = '1'
        // let cDom = this.getChildrenNode(this.objCurrentCachet,'qz-new')
        // cDom && (cDom.style.opacity = 0.8) // 拖动时更改签章样式

        if (
          this.chapterList.length &&
          parseInt(this.objCurrentCachet.style.left) > 20 &&
          parseInt(this.objCurrentCachet.style.left) > 20
        ) {
          let cindex = this.objCurrentCachet.dataset.cindex

          let x = 0
          let y = 0
          if (this.objCurrentCachet) {
            y =
              this.$el.querySelector('.cachet-box').getBoundingClientRect()
                .height ||
              this.$el.querySelector('.cachet-box').getBoundingClientRect()
                .clientHeight ||
              this.$el.querySelector('.cachet-box').getBoundingClientRect()
                .naturalHeight
          }

          let offX = parseFloat(
            (
              parseInt(this.objCurrentCachet.offsetLeft) / this.imgBox.width
            ).toFixed(4)
          )
          let offY = parseFloat(
            (
              parseInt(this.objCurrentCachet.offsetTop) / this.imgBox.height
            ).toFixed(4)
          )
          this.chapterList.forEach(t => {
            if (t.cindex == cindex) {
              t.offsetX = offX
              t.offsetY = offY
              t.imageHeight = parseFloat((y / this.imgBox.height).toFixed(4))
            }
          })
        }

        this.objCurrentCachet = null
      }
      this.$emit('chapterList', this.chapterList)
    },

    // 签章移动开始
    doCachetStart: function () {
      this.cachetMove = true
    },
    /** ******* 签章拖拽效果 end ************/
    // 更具cindx删除签章
    delChapter (cindx) {
      this.$emit('del-chapte', cindx)
    }
  },
  name: 'ContractView'
}
</script>

<style lang="less" scoped>
@goPageHeight: 0;
.big-box {
  vertical-align: top;
  position: relative;
  box-sizing: border-box;
  display: flex;
  .cont-box {
    position: relative;
    /*position: absolute;*/
    box-sizing: border-box;
    /*width: 1000px;*/
    /*height: 1416px;*/
    margin: 0 auto;
    border: 1px solid #f0f0f0;
    /*top: 0;*/
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #ffffff;
    display: inline-block;
    img {
      vertical-align: top;
      margin: 0 auto;
      display: block;
    }
  }

  .next,
  .pre {
    position: absolute;
    top: 45%;
    width: 40px;
    padding: 20px 0;
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
    color: #fff;
    font-size: 40px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .next {
    right: 0;
  }
  .pre {
    left: 0;
  }

  .cachet-box {
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    top: 300px;
    left: 500px;
    cursor: move;
  }

  .chapte-postion {
    box-sizing: border-box;
    width: 100px;
    height: 64px;
    text-align: center;
    line-height: 64px;
    background: rgba(0, 0, 0, 0.5);
    border: 2px dashed #fff;
    color: #fff;
    cursor: pointer;
  }

  .del-chapter {
    display: inline-block;
    font-size: 18px;
    position: absolute;
  }

  .del-chapter__create {
    left: -18px;
    top: calc(50% - 9px);
  }

  .del-chapter__sign {
    top: 0px;
    right: -18px;
    z-index: 50;
    color: #666666;
  }
}

.small-box {
  position: absolute;
  width: 140px;
  z-index: 20;
  opacity: 0.5;
  border: 1px solid #cccccc;

  .float-box {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    width: 30%;
    height: 30%;
    background: #ffffff;
    border: 1px dashed #ec1c1c;
    opacity: 0.5;
    cursor: move;
  }

  img {
    width: 100%;
    vertical-align: top;
    max-height: 195px;
  }
}

.contract-view {
  position: relative;
  vertical-align: top;
  /*width: 100%;*/
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /*width: 110% !important;*/
  /*padding-right: 10% !important;*/
  box-sizing: border-box;
}

.page-shwo {
  position: absolute;
  top: @goPageHeight;
  /*width: 100%;*/
  left: 20px;
  right: 10%;
  z-index: 10;
  padding: 16px 0;
}
.chapte-img {
  animation: chapteShow 0.6s ease-out;
}

// 新版样式
.qz-new {
  width: 110px;
  opacity: 1;
  // position: relative;
  h1 {
    height: 25px;
    background: #ffa7a7;
    font-size: 12px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(255, 255, 255, 1);
    padding-left: 5px;
    box-sizing: border-box;
    border-radius: 6px 6px 0px 0px;
    text-align: left;
    transition: all ease 0.2s;
  }
  .con {
    transition: all ease 0.2s;
    opacity: 0.7;
    font-size: 12px;
    text-align: center;
    position: relative;
    height: 85px;
    border: 1px solid rgba(236, 28, 28, 1);
    border-style: none dashed dashed dashed;
    box-sizing: border-box;
    padding: 18px 5px;
    border-radius: 0 0 10px 10px;
    background: #ffffff;
    text-overflow: ellipsis;
  }
  img {
    position: absolute;
    width: 15px;
    height: 15px;
    left: 50%;
    bottom: -8px;
    margin-left: -8px;
  }
  .del-chapter {
    position: absolute;
    top: -9px;
    right: -10px;
    color: #a1a1a1;
    z-index: 54;
  }

  .time {
    position: absolute;
    left: 4px;
    bottom: 2px;
    z-index: 2;
    font-size: 10px;
  }
}

.draging {
  /*opacity: 0.7;*/
  h1 {
    background: rgba(236, 28, 28, 1);
  }

  .con {
    opacity: 1;
  }
}

.d-new {
  position: relative;
  .del-chapter {
    color: #a1a1a1;
    top: -9px;
    right: -10px;
  }
}

.is-draging {
  /*border: 1px dashed #EC1C1C;*/
  /*padding: 10px 20px;*/
  /*margin-left: -10px;*/
  /*margin-top: -20px;*/

  &:after {
    position: absolute;
    top: -10px;
    bottom: -10px;
    right: -20px;
    left: -20px;
    /*padding: 10px 20px;*/
    content: ' ';
    border: 1px dashed #ec1c1c;
    border-radius: 2px;
  }

  .del-chapter {
    top: -19px;
    right: -30px;
  }

  .move {
    position: absolute;
    width: 15px;
    height: 15px;
    left: -28px;
    top: 50%;
    margin-top: -8px;
  }
}

@keyframes chapteShow {
  from {
    transform: scale(1.3);
  }
  to {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContractView.vue